/**
 * Created by Administrator on 2017/6/19.
 */
export default {
  api_url: '/v1'
}



// WEBPACK FOOTER //
// ./src/config/prod_config.js